import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { color } from '@/colors';
import { FlexCenHorVer } from '@/UI/styles';
import { LockKeyIcon } from '@/UI/Icons/LockKeyIcon';
import { I18N_KEYS } from '@/language/keys';
import { ErrorSidebar } from './ErrorSidebar';
import { ErrorDisplay } from './ErrorDisplay';

/**
 * Shown on a 403 from a workflow (`Recipe`) or a tool (`ToolView`). Names neither, since a viewer
 * without access can't be told which kind of page sat behind the link.
 *
 * `Recipe` only reaches this for signed-in viewers — it sends anonymous ones to `/signin` first.
 * `ToolView` shows it to both.
 */
export const NoAccessError = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <FlexCenHorVer sx={{ height: '100%', width: '100%', backgroundColor: color.Black100 }}>
      <ErrorSidebar />
      <ErrorDisplay
        icon={<LockKeyIcon />}
        title={t(I18N_KEYS.NO_ACCESS_PAGE.TITLE)}
        description={t(I18N_KEYS.NO_ACCESS_PAGE.DESCRIPTION)}
        actions={[
          {
            label: t(I18N_KEYS.NO_ACCESS_PAGE.ACTION),
            onClick: () => {
              navigate('/');
            },
          },
        ]}
      />
    </FlexCenHorVer>
  );
};
